// models/chat/channel-chat-info.ts

import { SnapshotOut, types } from "mobx-state-tree"

const LinkGroupModel = types.model("LinkGroup", {
  channel_id: types.number,
  group_id: types.union(types.number, types.string),
  group_title: types.string,
  is_active: types.number, // 或 types.boolean
})

export const ChannelChatInfoModel = types
  .model("ChannelChatInfo")
  .props({
    chat_id: types.number,
    collect_bots: types.optional(types.array(types.frozen()), []),
    compensate_bots: types.optional(types.array(types.frozen()), []),
    link_groups: types.optional(types.array(LinkGroupModel), []),
    owner_percentage: types.maybeNull(types.union(types.number, types.string)),
    official_percentage: types.maybeNull(types.union(types.number, types.string)),
    total_amount: types.maybeNull(types.union(types.number, types.string)), // 总担保资金
    official_balance_cny: types.optional(types.union(types.number, types.string), 0), // 当前担保资金（展示）
  })
  .actions((self) => ({
    update(data: Partial<typeof self> & Record<string, unknown>) {
      if (data.collect_bots) self.collect_bots.replace(data.collect_bots)
      if (data.compensate_bots) self.compensate_bots.replace(data.compensate_bots)
      if (data.link_groups) self.link_groups.replace(data.link_groups)
      if (data.owner_percentage !== undefined)
        self.owner_percentage = data.owner_percentage

      if (data.official_percentage !== undefined)
        self.official_percentage = data.official_percentage

      if (data.total_amount !== undefined)
        self.total_amount = data.total_amount

      const balance =
        data.official_balance_cny ??
        data.official_balance ??
        data.balance_cny
      if (balance !== undefined) self.official_balance_cny = balance
    },
    updateLinkGroupActive(group_id: number, is_active: number) {
      const group = self.link_groups.find((g) => g.group_id === group_id)
      if (group) group.is_active = is_active
    }
  }))
  export type ChannelChatInfo = SnapshotOut<typeof ChannelChatInfoModel>
